export const PreCheckoutUpsellModalNoMoreResults = () => (
  <div className='pb-24 pt-12 text-center'>
    <PreCheckoutUpsellModalNoMoreResultsIllustration />
    <p className='mt-12 text-neutral-800'>
      We are all out of recommendations
      <br />
      for you. Let’s checkout!
    </p>
  </div>
);

export const PreCheckoutUpsellModalNoMoreResultsIllustration = () => (
  <svg width='126' height='125' viewBox='0 0 126 125' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M43.0481 5.33888C40.6925 5.20203 38.6593 6.86373 38.5127 9.06303L47.046 9.57131C47.1926 7.37201 45.4136 5.47572 43.0579 5.3291L43.0481 5.33888Z'
      fill='#015F4E'
    />
    <path
      d='M58.3166 49.2761C60.2911 50.4784 62.9401 49.9604 64.2303 48.1129L57.0753 43.7437C55.785 45.5911 56.3422 48.0641 58.3166 49.2663V49.2761Z'
      fill='#015F4E'
    />
    <path
      d='M97.1413 14.8694C98.5097 13.0709 98.0601 10.5783 96.1442 9.30762L91.1885 15.8078C93.1141 17.0883 95.7826 16.6679 97.151 14.8694H97.1413Z'
      fill='#015F4E'
    />
    <path
      d='M117.531 14.2729C123.64 21.9656 128.811 36.7547 114.305 47.0083C101.999 56.177 88.2654 48.9144 82.1562 41.2217'
      fill='#F6E3CF'
    />
    <path
      d='M101.745 35.836C98.4019 38.3872 93.5635 37.7909 90.9536 34.4968L103.074 25.2598C105.684 28.5441 105.088 33.275 101.735 35.8262L101.745 35.836Z'
      fill='#FFC513'
    />
    <path
      d='M122.321 60.1064C124.139 60.1064 125.615 61.6215 125.517 63.4396C123.787 96.4682 96.447 122.723 62.9883 122.723C29.5296 122.723 2.1898 96.4682 0.449903 63.4396C0.352157 61.6215 1.82813 60.1064 3.64622 60.1064H122.321Z'
      fill='#EC2044'
    />
    <path
      d='M66.1352 29.1406C71.647 29.1406 76.1152 24.6724 76.1152 19.1606C76.1152 13.6488 71.647 9.18066 66.1352 9.18066C60.6234 9.18066 56.1553 13.6488 56.1553 19.1606C56.1553 24.6724 60.6234 29.1406 66.1352 29.1406Z'
      fill='#EC2044'
    />
    <path
      d='M70.28 3.95108C68.6769 2.26006 65.9987 2.06457 64.2881 3.51122L70.0942 9.63017C71.8048 8.18351 71.883 5.6421 70.28 3.95108Z'
      fill='#015F4E'
    />
    <path
      d='M73.7404 5.29996C76.0668 5.12401 78.1781 6.77593 78.4714 8.99478L70.0651 9.63014C69.7719 7.41129 71.414 5.4759 73.7404 5.29018V5.29996Z'
      fill='#015F4E'
    />
    <path
      d='M44.6021 119.898H81.8436V122.811C81.8436 123.544 81.2473 124.15 80.5044 124.15H45.9314C45.1983 124.15 44.5923 123.554 44.5923 122.811V119.898H44.6021Z'
      fill='#821125'
    />
    <path
      d='M33.7719 15.622C25.3853 12.6603 22.2183 11.8392 17.067 4.48864C12.8639 -1.18068 8.40664 -0.0663642 4.9464 2.32843C1.52527 4.76233 -1.04547 8.57445 2.85462 14.4588C8.01565 21.7996 7.71264 25.0546 7.64421 33.9495C7.61489 37.9278 8.78785 41.9843 11.2804 45.5227C17.6144 54.535 29.8425 56.6756 38.7277 50.4785C47.5835 44.2325 49.7242 32.0044 43.4098 22.9823C40.927 19.4341 37.5254 16.9513 33.7621 15.622H33.7719Z'
      fill='#89CFBB'
    />
    <path
      d='M27.1155 44.2129C32.8 44.2129 37.4082 39.6047 37.4082 33.9202C37.4082 28.2357 32.8 23.6274 27.1155 23.6274C21.431 23.6274 16.8228 28.2357 16.8228 33.9202C16.8228 39.6047 21.431 44.2129 27.1155 44.2129Z'
      fill='#003D32'
    />
  </svg>
);
